import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EntitlementService } from 'app/_services/entitlement.service';
import { EventEmitter } from '@angular/core';
import { Entitlement } from '../../_models/entitlement';
import { MatDialogRef } from '@angular/material/dialog';
import { AppDataService } from '../../_services/app_data.service';
import { sanctionedDomainValidator } from '../utils/validators';

@Component({
  standalone: false,
  selector: 'app-reset-assignee',
  templateUrl: './reset-assignee.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./reset-assignee.component.css']
})
export class ResetAssigneeComponent {
  @Input() dialogRef: MatDialogRef<any>;
  @Input() assignee_email: string;
  @Input() entitlement_id: number ;

  onReassigned = new EventEmitter<Entitlement>();

  resetAssigneeForm: UntypedFormGroup;
  isSanctionedLogin = false;

  constructor(private entitlementService: EntitlementService, private fb: UntypedFormBuilder, private appDataService: AppDataService) {
    this.resetAssigneeForm = this.fb.group({ // create form
      assignee_email: ['', [Validators.required, Validators.email, sanctionedDomainValidator(this.appDataService)]], // The assignee_email field will Never be pre-populated
    });
  }

  save() {
    if (this.resetAssigneeForm.valid) {
      const newEmail = this.resetAssigneeForm.controls['assignee_email'].value;
      this.entitlementService.updateAssigneeEmail(this.entitlement_id, this.assignee_email).subscribe(
        (success: Entitlement) => {
          this.onReassigned.emit(success);
        },
        error => {
          alert('Error on save: ' + error);
        }
      );
    }
  }
}
